import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import { BRAND, CTA_PROCESS } from '../data/mock';
import { Reveal, Magnetic, AnimatedDivider } from './effects';

const CTASection = () => {
  return (
    <section className="relative py-28 lg:py-44 overflow-hidden bg-[#72272D]">
      {/* Different bg image — chef cooking with steam (not used elsewhere) */}
      <div className="absolute inset-0">
        <img
          src="/site/cta-section-bg.webp"
          alt=""
          className="w-full h-full object-cover opacity-[0.16]"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#72272D] via-[#72272D]/90 to-[#72272D]/55" />
      </div>

      <div
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(circle at 1px 1px, rgba(255,255,255,1) 1px, transparent 0)',
          backgroundSize: '32px 32px',
        }}
      />

      <div className="container-x relative">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-7">
            <AnimatedDivider width="3rem" color="#C9A875" />
            <Reveal delay={100} y={8} duration={700}>
              <span className="text-[10.5px] tracking-[0.35em] uppercase text-[#C9A875] font-medium">
                Bir Sonraki Adım
              </span>
            </Reveal>
          </div>

          <Reveal delay={150}>
            <h2
              className="font-display text-[40px] lg:text-[64px] text-[#F5F0E5] leading-[1.04] tracking-[-0.02em]"
              style={{ fontWeight: 500 }}
            >
              48 saat içinde{' '}
              <span className="italic font-light text-[#C9A875]">size özel teklif</span>.
            </h2>
          </Reveal>

          <Reveal delay={350}>
            <p className="mt-7 text-cream-78 text-[16px] lg:text-[17px] max-w-2xl leading-[1.7]">
              Saha analizi, menü önerisi ve sabit fiyat garantili sözleşme — tek bir formla başlatın. Müşteri yöneticimiz aynı gün size geri döner.
            </p>
          </Reveal>

          <Reveal delay={500}>
            <div className="mt-10 flex flex-wrap items-center gap-5">
              <Magnetic strength={0.22}>
                <Link
                  to="/iletisim"
                  className="group inline-flex items-center gap-3 bg-[#C9A875] text-[#72272D] px-8 py-[18px] text-[12px] tracking-[0.22em] uppercase font-semibold rounded-sm transition-colors duration-300 hover:bg-[#E0C896]"
                >
                  Hemen Teklif Al
                  <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                </Link>
              </Magnetic>
              <a
                href={`tel:${BRAND.phoneRaw}`}
                className="inline-flex items-center gap-2 text-[#F5F0E5] text-[12.5px] tracking-[0.18em] uppercase font-medium border-b border-brand-light/40 pb-1.5 hover:border-[#C9A875] hover:text-[#C9A875] transition-colors"
              >
                <Phone size={13} className="text-[#C9A875]" /> {BRAND.phone}
              </a>
            </div>
          </Reveal>
        </div>

        {/* Mini process — staggered reveal */}
        <div className="mt-20 lg:mt-28 max-w-4xl">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-px bg-[#C9A875]/20">
            {CTA_PROCESS.map((p, i) => (
              <Reveal key={i} delay={700 + i * 140} y={20}>
                <div className="bg-[#72272D] px-6 lg:px-8 py-7 lg:py-9 flex items-baseline gap-5 transition-colors duration-500 hover:bg-[#5C1B22]">
                  <span className="font-display text-[#C9A875] text-[34px] lg:text-[42px] numeric leading-none">
                    {p.num}
                  </span>
                  <span className="font-display text-[#F5F0E5] text-[18px] lg:text-[22px] leading-tight tracking-[-0.005em]">
                    {p.label}
                  </span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
